import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import lodash from 'lodash';
import { BOREHOLE_INSTALLATION_BORELINE_TYPES } from '../../../appConstants';

interface IRisingMainBorelineSelectorProps {
    value : number;

    onChange : (value : number) => void;

    disabled ?: boolean;
}

interface IRisingMainBorelineSelectorState {}

export default class RisingMainBorelineSelector extends React.Component<IRisingMainBorelineSelectorProps, IRisingMainBorelineSelectorState> {
    constructor(props : IRisingMainBorelineSelectorProps) {
        super(props);
        this.state = {};
    }

    private readonly onChange = (event : React.ChangeEvent<{ name ?: string | undefined; value : unknown }>) => {
        this.props.onChange(Number(event.target.value));
    };

    public readonly render = () => {
        const { value, disabled } = this.props;

        return (<React.Fragment>
            <div className={'flx1 ais p5 mb10 pr20'}>
                <FormControl margin='normal' fullWidth>
                    <InputLabel shrink={!!value} htmlFor='RisingMainBoreline'>Rising Main Type</InputLabel>
                    <Select
                        disabled={disabled}
                        fullWidth
                        id='value'
                        value={!value ? '' : value}
                        onChange={this.onChange}>
                        <MenuItem value=''>
                            <em>None</em>
                        </MenuItem>
                        {
                            lodash.map(BOREHOLE_INSTALLATION_BORELINE_TYPES, n => (
                                <MenuItem key={`${n}_RisingMainBoreline`} value={n}>
                                    {n}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </div>
        </React.Fragment>);
    };
}
